import { log } from 'next-axiom'

const logWrapper = (message: string, args?: Record<string, unknown>) => {
  //console.log(message, args)
  log.info(message, args)
}

export default logWrapper
